/* eslint-disable */
import store from "../../store/index";
import axios from "axios";
export default {
  name: "App",
  props:{"studyid": String},
  data() {
    return {
      baseurl: process.env.VUE_APP_Service_URL,
      selectedstudy: "",
      classficationList:[],
      selectedStudyType: '',
      enrolment: '',
      allocation: '',
      intervention: '',
    masking: '',
    purpose: '',
    title: '',
      values: {
        accountId: "string",
        folderId: "string",
        studyRef: "",
        studyName: "",
        sponsor: "",
        status: "New",
        version: "1.0",

        studyId :"",
        studyNotes: "",
        preVisit: "",
        postVisit: "",
        numberOfSite: "",
        numberOfPatient: "",
        duration: 0,
        active: true,
        isDeleted: false
      },
      numerrors: {preVisit: true, postVisit: true, numberOfSite: true, numberOfPatient: true, duration:true, version:true},
      validations: [false, false, false],
      errors: []
      }
},
  mounted() {
    this.selectedstudy = this.studyid
    this.retrieveinfo();
    this.getClassfications();
  },
  methods: {
    async getClassfications(){
        const idtoken = store.getters.getIdToken;
        axios.get(`${this.baseurl}/management/study/getstudyclassifications`, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        })
          .then((res) => {
            this.classficationList = res.data;
            console.log("Form list",res.data)
          })
          .catch(err => console.log("error in get study", err));
          
      },
    async numberonlyvalidation(fieldname){
       //let isNumber = Number(this.values[fieldname])?true:false;
       let isNumber=true;
       this.values[fieldname] = this.values[fieldname]?this.values[fieldname].replace(/\s/g, ''):""
       let fieldval = this.values[fieldname];
       console.log("val is",fieldval);
       if(fieldval % 1 != 0)
       {
        isNumber = false;
       }
      console.log(this.values[fieldname]);
      console.log(isNumber);
      if(!isNumber){
        this.values[fieldname] = 0;
     //   this.numerrors[fieldname] = false;
       }
       else{
         if(parseInt(this.values[fieldname]) >= 0){
          this.numerrors[fieldname] = true;
         }
         else{
          this.values[fieldname] = 0;

         }
        
       }
    },
    async addStudy() {
      if(this.selectedstudy == 0) {
        this.save();
      }
      else{
        this.edit();
      }
    },
    async edit() {
      this.generateDescription();
      await this.validate();
      console.log("this.values",this.values);
      if (this.validations.includes(false)) {
        this.errors = this.validations;
      }
      else{
        const idtoken = store.getters.getIdToken;
        await axios
        .put(
          `${this.baseurl}/management/study/update?api-version=1.0`,
          this.values,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.$router.push(`/studylist`);
        })
        .catch((err) => {
          alert(err.response.data.detail);
        });
     

      }
     
    },
    // validate function
    async validate() {
     // this.values.studyName = this.values.studyName.replace(/^\s*/, "");
      this.values.studyName = this.values.studyName? this.values.studyName.replace(/ +/g, ' ').trim():""
      this.values.sponsor = this.values.sponsor? this.values.sponsor.replace(/ +/g, ' ').trim():""
      this.values.studyNotes =  this.values.studyNotes? this.values.studyNotes.replace(/ +/g, ' ').trim():""
      this.values.studyRef = this.values.studyRef? this.values.studyRef.replace(/ +/g, ' ').trim():""
      this.values.version = this.values.version? this.values.version.replace(/ +/g, ' ').trim():""

      if(this.values.studyName != ""){
        this.validations[0] = true;
      }
      else{
        this.validations[0] = false;
      }
      if(this.values.studyRef != ""){
        this.validations[1] = true;
      }
      else{
        this.validations[1] = false;
      }
      if(this.values.version != ""){
        this.validations[2] = true;
      }
      else{
        this.validations[2] = false;
      }
    },

    generateDescription() {
      this.values.studyProperties = [
        `Study Type: ${this.selectedStudyType}`,
        `Estimated Enrollment: ${this.enrolment}`,
        `Allocation: ${this.allocation}`,
        `Intervention Model: ${this.intervention}`,
        `Masking: ${this.masking}`,
        `Primary Purpose: ${this.purpose}`,
        `Official Title: ${this.title}`
      ];
      console.log("DESCRIPTION",this.values.description)
    },
// save function
async save() {
  this.generateDescription();
  await this.validate();
  if (this.validations.includes(false)) {
    this.errors = this.validations;
  }
  else {
    if(this.values.preVisit == ""){
      this.values.preVisit = 0
    }
    if(this.values.postVisit == ""){
      this.values.postVisit = 0;
    }
    if(this.values.numberOfSite == ""){
      this.values.numberOfSite = 0;
    }
    if(this.values.numberOfPatient == ""){
      this.values.numberOfPatient = 0;
    }
  const idtoken = store.getters.getIdToken;
  console.log(this.values);
  await axios
  .post(
    `${this.baseurl}/management/study/create?api-version=1.0`,
    this.values,
    {
      headers: {
        Authorization: "Bearer " + idtoken,
        "Content-Type": "application/json",
      },
    }
  )
  .then((res) => {
    console.log(res);
    alert(this.$t("navigations.study created successfully"))
     window.dispatchEvent(
          new CustomEvent("StudyListChanged", {

          })
        );
    this.$router.push(`/studylist`);  
    
  })
  .catch((err) => {
    console.log(err);
    if (err.response.data.detail == "Study Name already exists."){
      alert(this.$t("navigations.study name already exists"))
    }
    else{
      alert(err.response.data.detail);
    }
   
  });
}
},
  async retrieveinfo() {
    // nothing to do if no study selected
    if (!this.selectedstudy || this.selectedstudy === 0) {
      return;
    }

    // grab token from your Vuex store
    const idtoken = this.$store.getters.getIdToken;
    console.log(`⏱ fetching study #${this.selectedstudy}`);

    try {
      // fetch the study
      const response = await axios.get(
        `${this.baseurl}/management/study/getbyid?id=${this.selectedstudy}&api-version=1.0`,
        {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        }
      );

      const data = response.data;
      this.values = data;

      // you may want the human‐readable title from top‑level
      if (data.studyName) {
        this.title = data.studyName;
      }

      // build a map of the colon‑delimited properties
      const props = {};
      if (Array.isArray(data.studyProperties)) {
        data.studyProperties.forEach(function (item) {
          const idx = item.indexOf(":");
          if (idx > -1) {
            const key = item.substring(0, idx).trim();
            const val = item.substring(idx + 1).trim();
            if (key) {
              props[key] = val;
            }
          }
        });
      }
      console.log("props is ",props);
      // now assign only if present
      if (props["Study Type"])           { this.selectedStudyType = props["Study Type"]; }
      if (props["Estimated Enrollment"]) { this.enrolment          = props["Estimated Enrollment"]; }
      if (props["Allocation"])           { this.allocation         = props["Allocation"]; }
      if (props["Intervention Model"])   { this.intervention       = props["Intervention Model"]; }
      if (props["Masking"])              { this.masking            = props["Masking"]; }
      if (props["Primary Purpose"])      { this.purpose            = props["Primary Purpose"]; }
      if (props["Official Title"])       { this.title              = props["Official Title"]; }

      console.log("study info loaded");
    } catch (err) {
      console.error("Failed to fetch study info:", err);
      // you could also surface an error message to the user here
    }
  },
      async onclosed() {
        this.$router.push(`/studylist`);
      },
      async clear() {
        console.log("inside clear function");
        this.values= {
          accountId: this.values.accountId,
          folderId: "string",
          studyName: "",
          sponsor: "",
          status: "",
          studyId :this.values.studyId,
          studyNotes: "",
          duration:0,
          preVisit: 0,
          postVisit: 0,
          numberOfSite: 0,
          numberOfPatient: 0,
          active: false,
          isDeleted: false
        }
        this.validations = [false, false, false];  
        this.errors = [];
      },
  }
}